import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { config } from '../config/config';
import { handleHashNavigation } from '../utils/navigation';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handlePhoneClick = () => {
    window.location.href = `tel:${config.business.contact}`;
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    closeMobileMenu();
    handleHashNavigation(`#${sectionId}`, navigate);
  };

  return (
    <nav>
      <Link to="/" className="logo" onClick={closeMobileMenu}>
        <img src="/logo.jpeg" alt="JS Kuber Logo" className="logo-img" />
        <span className="logo-text">JS <span className="logo-text-gold">KUBER</span></span>
      </Link>
      <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
        <span className={mobileMenuOpen ? 'hamburger open' : 'hamburger'}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
      <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <li><a href="#home" onClick={(e) => handleSectionClick(e, 'home')}>Home</a></li>
        <li><a href="#services" onClick={(e) => handleSectionClick(e, 'services')}>Services</a></li>
        <li><a href="#process" onClick={(e) => handleSectionClick(e, 'process')}>Process</a></li>
        <li><a href="#reviews" onClick={(e) => handleSectionClick(e, 'reviews')}>Reviews</a></li>
        <li><a href="#locations" onClick={(e) => handleSectionClick(e, 'locations')}>Locations</a></li>
        <li><Link to="/query" onClick={closeMobileMenu}>Query</Link></li>
        <li><Link to="/privacy-policy" onClick={closeMobileMenu}>Privacy Policy</Link></li>
      </ul>
      <button className="nav-phone" onClick={handlePhoneClick}>
        📞 <span className="phone-text">{config.business.contact}</span>
      </button>
    </nav>
  );
};

export default Navbar;
